import React, { useState, useEffect, useRef } from 'react';

import { func, string, shape, bool, arrayOf } from 'prop-types';

import { isEmpty } from 'Utils';

import { SelectorTray } from 'Components';

import { ArrowDownIcon, ArrowUpIcon } from 'Assets/icons';

import './selector.scss';

export default function Selector({
  elements,
  current,
  onSelect,
  placeholder,
  headerText,
  outline,
  fullWidthTray,
  width,
  iconOnly,
  alignment
}) {
  const [isTrayOpen, setIsTrayOpen] = useState(false);
  const trayWrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (
        trayWrapperRef.current &&
        !trayWrapperRef.current.contains(e.target)
      ) {
        setIsTrayOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [trayWrapperRef]);

  function handleSelect(element) {
    onSelect(element);
    setIsTrayOpen((prev) => !prev);
  }

  return (
    <div
      className={`selector-wrapper${
        iconOnly ? ' selector-wrapper--icon-only' : ''
      }`}
      style={width ? { width } : {}}
      ref={trayWrapperRef}
    >
      <button
        className={`selector-btn sdp-card ${
          !outline ? 'selector-btn--no-outline' : ''
        }`}
        style={{ padding: 0, borderRadius: '5px' }}
        type="button"
        onClick={() => setIsTrayOpen((prev) => !prev)}
      >
        <p className={`selector-btn-icon ${outline ? '' : 'icon-border'}`}>
          {!isEmpty(current)
            ? current.icon
            : !elements.length
            ? ''
            : elements[0].icon}
        </p>
        <p
          className={`selector-btn-name  ${
            fullWidthTray ? 'text-truncate ' : ''
          }`}
        >
          {!isEmpty(current) ? current.name : placeholder}
        </p>
        <p className="selector-btn-arrow">
          {isTrayOpen ? <ArrowUpIcon /> : <ArrowDownIcon />}
        </p>
      </button>

      {isTrayOpen && (
        <SelectorTray
          fullWidthTray={fullWidthTray}
          headerText={headerText}
          elements={elements}
          alignment={alignment}
          onSelect={(e) => handleSelect(e)}
        />
      )}
    </div>
  );
}

Selector.propTypes = {
  elements: arrayOf(shape({})),
  current: shape({}),
  onSelect: func,
  placeholder: string,
  headerText: string,
  outline: bool,
  fullWidthTray: bool,
  width: string,
  iconOnly: bool,
  alignment: string
};

Selector.defaultProps = {
  elements: [],
  current: {},
  onSelect: () => {},
  placeholder: 'select...',
  headerText: '',
  outline: false,
  fullWidthTray: false,
  width: '',
  iconOnly: false,
  alignment: 'right'
};
